export default __webpack_public_path__ + "static/media/uz.e22893e4.svg";